import React from "react";
import {useTranslation} from "react-i18next";
import {Person} from "../../../services/interface/query/person";
import GraphicMachiningComponent from "./GraphicMachiningComponent";

interface Props {
    person?: Person;
}
export default function GraphicMachining({person}: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string };

    return (
        <>
            <GraphicMachiningComponent
                className={'rounded-[5px] !border-[1px] border-secondary'}
                title={t('graphic-machining')}
                msj={t('graphic-machining')}
                {...{person}}
            />
        </>
    )
}
